import { gql } from '@apollo/client';

export const GENERATE_DAILY_TASK_DETAIL_DOWNLOAD_REPORT_FOR_DSP = gql`
    mutation GenerateDailyTaskDetailDownloadReportForDsp(
        $taskDate: String!
        $statusField: String
        $statusFields: [String!]
        $warehouseId: Long
        $warehouseIds: [Long!]
        $hubId: Long
        $dspIds: [Long!]
        $areaIds: [Long!]
        $driverIds: [Long!]
        $cityNames: [String!]
        $ids: [String!]
        $viewMode: String
        $timezone: String
        $locale: String
    ) {
        generateDailyTaskDetailDownloadReportForDsp(
            taskDate: $taskDate
            statusField: $statusField
            statusFields: $statusFields
            warehouseId: $warehouseId
            warehouseIds: $warehouseIds
            hubId: $hubId
            dspIds: $dspIds
            areaIds: $areaIds
            driverIds: $driverIds
            cityNames: $cityNames
            ids: $ids
            viewMode: $viewMode
            timezone: $timezone
            locale: $locale
        )
    }
`;

export interface GenerateDailyTaskDetailDownloadReportForDspVariables {
    taskDate: string;
    statusField?: string | null;
    statusFields?: string[] | null;
    warehouseId?: number | null;
    warehouseIds?: number[] | null;
    hubId?: number | null;
    dspIds?: number[] | null;
    areaIds?: number[] | null;
    driverIds?: number[] | null;
    cityNames?: string[] | null;
    ids?: string[] | null;
    viewMode?: string | null;
    timezone?: string | null;
    locale?: string | null;
}

export interface GenerateDailyTaskDetailDownloadReportForDspResponse {
    generateDailyTaskDetailDownloadReportForDsp: string;
}
